export class CreateConveyanceRequest {
  Name: string;
  From: string;
  To: string;
  Description: string;
}
